import { useQuery } from '@tanstack/react-query';
import { loadActiveFlights, loadActiveTrucks } from '../api';

// Quiet on 4xx (e.g. 404 when the endpoint is not deployed); retry once on network/5xx.
const retryUnlessClientError = (count, err) => !(err?.status >= 400 && err?.status < 500) && count < 1;

/**
 * Air and truck layers for the Global Produce Map.
 *
 * Both refresh on the same cadence as sea. Neither is live-tracked — their
 * positions are interpolated from the ETD..ETA schedule in BigQuery — so a
 * tighter interval would only re-fetch the same numbers.
 */
export const useActiveFlights = () => useQuery({
  queryKey: ['air-tracking', 'active'],
  queryFn: loadActiveFlights,
  retry: retryUnlessClientError,
  staleTime: 5 * 60 * 1000,
  refetchInterval: 10 * 60 * 1000,
});

export const useActiveTrucks = () => useQuery({
  queryKey: ['truck-tracking', 'active'],
  queryFn: loadActiveTrucks,
  retry: retryUnlessClientError,
  staleTime: 5 * 60 * 1000,
  refetchInterval: 10 * 60 * 1000,
});
